const POST_DETAIL_PATH_PATTERN = /^\/c\/[^/]+\/[^/]+\/?$/;

// These routes register mobile shell chrome overrides from page-level effects.
// Defer the default community TopBar for one frame so those overrides can
// register without flashing the wrong chrome. Longer term, lifting the mobile
// shell provider above route boundaries should let us remove this route list.
//
// `/s/` = space group pages, which hide the default TopBar via PageHeader's
// `useMobileHideTopNav` (itself a page-level effect registration, same race
// as the override-based routes above). Trailing slash on purpose: `/s` alone
// would also catch `/spaces` and `/settings/*`, which want the default TopBar.
export const shouldDeferDefaultTopBar = (pathname: string) =>
  pathname.startsWith("/notifications") ||
  pathname.startsWith("/messages") ||
  pathname.startsWith("/c/") ||
  pathname.startsWith("/s/") ||
  POST_DETAIL_PATH_PATTERN.test(pathname) ||
  pathname.startsWith("/settings/members/invite") ||
  pathname.startsWith("/settings/workflows/new") ||
  pathname.startsWith("/settings/workflows/view") ||
  pathname.startsWith("/settings/workflows/edit");
